import { SMART_FIELDS_SOURCES_MOCKED_DATA } from '@dealstack/shared/lib/common/business/smartFields.ts';

export const MONACO_EDITOR_SOURCES_TYPE_DECLARATION = `
        declare namespace CustomTypes {
            interface Data {
                currentDate: Date;
                deal: {
					projectRepresentativePerson: {
						positionInCompany?: string | null;
						signatureImageFileId?: string | null;
					};
				};
				mip: {
					name?: string | null;
					currency?: string | null;
					entity: {
						name?: string | null;
						number?: string | null;
						address: {
							country?: string | null;
							city?: string | null;
							postCode?: string | null;
							street?: string | null;
							houseNumber?: string | null;
							singleAddressString?: string | null;
						};
					};
					bankAccount: {
						bankName?: string | null;
						country?: string | null;
						swiftCode?: string | null;
						accountHolder?: string | null;
						iban?: string | null;
						accountNumber?: string | null;
					};
				};
				investor: {
					firstName: string | null;
					lastName: string | null;
					email: string;
					birthDate: Date | null;
					phoneNumber: string | null;
					telephonePrefix: string | null;
					address: {
						country?: string | null;
						city?: string | null;
						postCode?: string | null;
						street?: string | null;
						houseNumber?: string | null;
						singleAddressString?: string | null;
					};
					bankAccount: {
						bankName?: string | null;
						country?: string | null;
						swiftCode?: string | null;
						accountHolder?: string | null;
						iban?: string | null;
						accountNumber?: string | null;
					};
					additionalDetails: {
						taxResidency?: string | null;
						tin?: string | null;
						countryOfBirth?: string | null;
						countryOfBirthName?: string | null;
						placeOfBirth?: string | null;
					};
					taxResidences: {
						countryCode?: string | null;
						country?: string | null;
						authority?: string | null;
						number?: string | null;
					}[];
					employment: {
						employerName?: string | null;
						employerNumber?: string | null;
						employerAddress: {
							country?: string | null;
							city?: string | null;
							postCode?: string | null;
							street?: string | null;
							houseNumber?: string | null;
							singleAddressString?: string | null;
						};
						jobTitle?: string | null;
						startDate?: Date | null;
						endDate?: Date | null;
						employeeReference?: string | null;
						isPrimary: boolean;
					}[];
					nationalities: {
						countryCode?: string | null;
						country?: string | null;
						nationality?: string | null;
					}[];
					shareWithInvestorSecurityValuation: boolean;
				};
				vehicleData: {
					pivName?: string | null;
					corporateNumber?: string | null;
					address: {
						country?: string | null;
						city?: string | null;
						postCode?: string | null;
						street?: string | null;
						houseNumber?: string | null;
						singleAddressString?: string | null;
					};
				};
				representative: {
					firstName?: string | null;
					lastName?: string | null;
					email?: string;
					birthDate?: Date | null;
					phoneNumber?: string | null;
					telephonePrefix?: string | null;
					address: {
						country?: string | null;
						city?: string | null;
						postCode?: string | null;
						street?: string | null;
						houseNumber?: string | null;
						singleAddressString?: string | null;
					};
				};
				declarations: {
					isPoliticallyExposed: boolean;
					isBeneficialOwner: boolean;
					fundsSource: {
						salary: boolean;
						inheritance: boolean;
						investmentIncome: boolean;
						personalSavings: boolean;
						other: boolean;
					};
				};
				holdings: {
					unitsHeld?: number;
					fairMarketValue?: number;
					costOfAcquisition?: number;
					votes?: number;
					security: {
						name: string;
						type: string;
						currency: string;
						issuer: {
							name?: string | null;
							number?: string | null;
							address: {
								country?: string | null;
								city?: string | null;
								postCode?: string | null;
								street?: string | null;
								houseNumber?: string | null;
								singleAddressString?: string | null;
							};
						};
					};
					transactions: {
						date: Date;
						units?: number;
						cost?: number;
						holderRole: HolderRole;
					}[];
				}[];
				loans: {
					totalValue?: number;
					funder: {
						name?: string | null;
						number?: string | null;
						address: {
							country?: string | null;
							city?: string | null;
							postCode?: string | null;
							street?: string | null;
							houseNumber?: string | null;
							singleAddressString?: string | null;
						};
					};
				}[];
				customDetails?: {
					id?: string | null;
					question?: string | null;
					answer?: string | null;
					entityType?: CustomDetailEnum | null;
				}[];
			}
        }
    `;
export const MONACO_EDITOR_SOURCES_MODEL_DECLARATION = `const data: CustomTypes.Data = ${JSON.stringify(SMART_FIELDS_SOURCES_MOCKED_DATA)}`;

export interface CustomDetailDefinitionSource {
	id: string;
	question: string;
	answer?: string;
}

export const mapCustomDetailsDefinitionToSource = (
	definition: { id?: string; localId?: string; name: string },
	index: number
): CustomDetailDefinitionSource => {
	return {
		id: definition.localId ?? (definition.id as string),
		question: definition.name,
		answer: `investor answer example ${index + 1}`,
	};
};
